import React from 'react';

const CantorContext = React.createContext();

export default CantorContext;